module.exports = __webpack_public_path__ + "img/Vector (7).da805140.svg";